export class PatientStatus{

Status: string;
PatientStatusId: number;
IsActive: boolean;
}